module.exports = __webpack_public_path__ + "img/logo.f9e3f38f.png";